/* eslint-disable max-len */
import React from 'react';

interface Props {
  color?: string;
}

export default function EditIcon({ color = '#047A9C' }: Props) {
  return (
    <path
      d="M1 12.7827L12.1792 1.58579C12.959 0.804738 14.2233 0.804738 15.0032 1.58579L16.4151 3C17.195 3.78105 17.195 5.04738 16.4151 5.82843L5.26123 17H1.49921C1.2235 17 1 16.7761 1 16.5V12.7827ZM10.6284 5.61586L12.3928 7.38027L4.53555 15.25H2.75V13.5068L10.6284 5.61586ZM13.4176 2.82224L11.8649 4.37744L13.6293 6.14185L15.1767 4.59197C15.2744 4.49411 15.2744 4.33431 15.1767 4.23646L13.7647 2.82224C13.6686 2.72592 13.5138 2.72592 13.4176 2.82224Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
    />
  );
}
